import { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types';
import { Twitter } from 'next/dist/lib/metadata/types/twitter-types';
import { TWITTER_CREATOR, TWITTER_SITE } from '../_constants/twitter-detail';
export const MAXIMUM_ADD_TO_CART_COUNTER_SHOW_LIMIT = 99;
export const SHOW_MORE_BUTTON_CHARACTER_LIMIT = 420;
export const PRODUCT_PAGE_ROUTE = 'products';
export const SHOULD_NOINDEX_PDPS = process.env.NEXT_PUBLIC_SHOULD_NOINDEX_PDPS === 'true';
export const SHOULD_NOFOLLOW_PDPS = process.env.NEXT_PUBLIC_SHOULD_NOFOLLOW_PDPS === 'true';
export const PDP_OPEN_GRAPH_METADATA: OpenGraph = {
  type: 'website',
  siteName: 'خانومی'
};
export const PDP_TWITTER_CART_METADATA: Twitter = {
  card: 'summary',
  site: `@${TWITTER_SITE}`,
  creator: `@${TWITTER_CREATOR}`
};
export const WEIGHT_UNITS = ['kg', 'gr', 'g', 'mg'];
export const VOLUME_UNITS = ['ml', 'l'];
export const UNIT_TRANSLATIONS: Record<(typeof WEIGHT_UNITS | typeof VOLUME_UNITS)[number], string> = {
  kg: 'کیلوگرم',
  gr: 'گرم',
  g: 'گرم',
  mg: 'میلی‌گرم',
  ml: 'میلی‌لیتر',
  l: 'لیتر'
};